"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPORTANT_BOM_REVIEW_MIN_PINS = void 0;
exports.resolveBomReviewGroupKey = resolveBomReviewGroupKey;
exports.findBomReviewDatasheetSource = findBomReviewDatasheetSource;
exports.resolveBomReviewDatasheetFileId = resolveBomReviewDatasheetFileId;
exports.groupBomReviewItems = groupBomReviewItems;
exports.isImportantBomReviewRow = isImportantBomReviewRow;
exports.isBomReviewRowWithoutDatasheet = isBomReviewRowWithoutDatasheet;
const manufacturer_names_1 = require("./manufacturer-names");
exports.IMPORTANT_BOM_REVIEW_MIN_PINS = 3;
const PER_INSTANCE_METADATA_FIELDS = new Set(['reference']);
function metadataFingerprint(metadata) {
    return JSON.stringify(Object.entries(metadata)
        .filter(([key]) => !PER_INSTANCE_METADATA_FIELDS.has(key))
        .sort(([a], [b]) => a.localeCompare(b)));
}
function resolvePartKey(item) {
    if (item.manufacturerPartNumber !== null && item.manufacturerPartNumber.trim() !== '') {
        return item.manufacturerPartNumber;
    }
    if (item.staticMetadata.value !== null && item.staticMetadata.value.trim() !== '') {
        const { value, numComponentPins, metadata } = item.staticMetadata;
        return `__value__${value}__pins__${numComponentPins}__${metadataFingerprint(metadata)}`;
    }
    return `__null__${item.bomItemId}`;
}
function resolveBomReviewGroupKey(item) {
    return [resolvePartKey(item), manufacturer_names_1.ManufacturerNames.matchKey(item.manufacturerName)].join('__');
}
function findBomReviewDatasheetSource(group) {
    return (group.find((item) => (item.uploadedDatasheetFileId ?? null) !== null) ??
        group.find((item) => item.datasheetFileId !== null));
}
function resolveBomReviewDatasheetFileId(group) {
    const source = findBomReviewDatasheetSource(group);
    return source?.uploadedDatasheetFileId ?? source?.datasheetFileId ?? null;
}
function groupBomReviewItems(items) {
    const groups = new Map();
    for (const item of items) {
        const key = resolveBomReviewGroupKey(item);
        const existing = groups.get(key);
        if (existing !== undefined) {
            existing.push(item);
        }
        else {
            groups.set(key, [item]);
        }
    }
    return groups;
}
function isImportantBomReviewRow(row) {
    return row.numPins >= exports.IMPORTANT_BOM_REVIEW_MIN_PINS && row.datasheetFileId === null;
}
function isBomReviewRowWithoutDatasheet(row) {
    return row.datasheetFileId === null;
}
//# sourceMappingURL=customer-bom-review-grouping.js.map